import JSONParser from './JSONParser.js'
// author: Sanjid Islam Chowdhury
const tabLayout = {
	init: function (wrapper) {
		
		// query all data-tabs attr
		if (wrapper.classList.contains('tab-layout-initialized')) return

		wrapper.classList.add('tab-layout-initialized')
		// now, data-tabs contain an array of titles and hrefs
		// remove comma before } if present in the data-tabs attr
		const tabData = JSONParser(wrapper.dataset.tabs)
		const tabs = []

		//push tabElement which are present in the wrapper
		wrapper.querySelectorAll('a').forEach(tab => {
			tab.classList.add('tab')
			tab.index = tabs.length
			tabs.push(tab)
		})


		// create tab elements from the data
		tabData.forEach(data => {
			// create a new tab element
			const tabElement = document.createElement('a')
			tabElement.index = tabs.length

			tabElement.classList.add('tab')
			tabElement.innerText = data.title

			// add href if present
			if (data.href) {
				tabElement.setAttribute('href', data.href)
			}

			tabs.push(tabElement)

			wrapper.appendChild(tabElement)
		})

		// now add functionality to the tabs
		tabs.forEach(tabElement => {

			if (tabElement.getAttribute('href') && tabElement.getAttribute('href')[0] == '#') {
				tabElement.addEventListener('click', e => {
					e.preventDefault()
				})
			}

			tabElement.addEventListener('click', e => {
				// remove all active classes
				let prev_active_tab = 0
				tabs.forEach(tab => {
					if (tab.classList.contains('active')) {
						tab.classList.remove('active', 'slide-left', 'slide-right')

						// get the content of this tab if it is a valid querySelector
						if (tabElement.getAttribute('href') && tab.getAttribute('href')[0] == '#') {
							document.querySelector(tab.getAttribute('href')).classList.add('hidden')
						}
						prev_active_tab = tab.index
					}
				})

				if (tabElement.index > prev_active_tab) {
					tabElement.classList.add('active', 'slide-left')
				} else {
					tabElement.classList.add('active', 'slide-right')
				}

				// display content related to href
				if (tabElement.getAttribute('href') && tabElement.getAttribute('href')[0] == '#') {
					document.querySelector(tabElement.getAttribute('href')).classList.remove('hidden')
				}
			})
		})

		// activate the tab
		tabs[Number(wrapper.getAttribute('data-active-tab')) || 0].dispatchEvent(new Event('click'))

	}
}

export default tabLayout;